<!--
公告详情
-->
<template>
  <div class="box-page" v-loading="loading">
    <div class="flex-c-s box-title-line">
      <div class="detail-nav flex-col-center">
        <div style="cursor: pointer;" @click="goBack">首页</div>
        <div class="nav-icon"></div>
        <div class="nav-now">公告详情</div>
      </div>
    </div>

    <template v-if="detail">
      <div class="detail-header">
        <div class="header-title">
          {{detail.title}}
        </div>
        <div class="header-date">{{detail.readCount}}人阅读 {{detail.time}}</div>
      </div>

      <div class="detail-content">
      	<el-alert :title="detail.description" type="info" :closable="false" v-if="detail.description && detail.description!=' '">
      	</el-alert>
      	<div class="ql-editor" v-html="detail.content"></div>
      </div>
    </template>

    <!-- <div class="detail-btns">
      <div class="btn">上一篇</div>
      <div class="btn">下一篇</div>
    </div> -->
  </div>
</template>

<script>
	import 'quill/dist/quill.core.css'
	import 'quill/dist/quill.snow.css'
	import 'quill/dist/quill.bubble.css'
export default {
  components: {},
  data() {
    return {
      id: '', // 公告id
      detail: '', // 公告详情
      loading: false
    }
  },
  computed: {},
  watch: {},
  mounted() {
    this.id = this.$route.query.id
    this.getNoticeDetail()
  },
  methods: {
    // 获取公告详情
    getNoticeDetail() {
      this.loading = true
      this.$api.home
        .noticeDetail(this.id)
        .then(({ data }) => {
          this.loading = false
          if (data.code == 200) {
            this.detail = data.data
          }
        })
        .catch(() => {
          this.loading = false
        })
    },

    goBack() {
      this.$router.push({ path: '/' })
    }
  }
}
</script>
<style lang="scss" scoped>
.detail-nav {
  font-size: 16px;
  font-weight: bold;
  color: rgba(51, 51, 51, 0.4);
  .nav-icon {
    width: 7px;
    height: 7px;
    margin: 0 16px;
    border-right: 2px solid rgba(64, 66, 79, 0.4);
    border-bottom: 2px solid rgba(64, 66, 79, 0.4);
    transform: rotate(-45deg);
  }
  .nav-now {
    color: #333333;
  }
}
.detail-header {
  width: 80%;
  margin: 0 auto;
  padding: 40px 0 25px 0;
  border-bottom: 1px dashed rgba(0, 0, 0, 0.2);
  text-align: center;
  .header-title {
    margin-bottom: 25px;
    font-size: 20px;
    color: #333333;
  }
  .header-date {
    font-size: 16px;
    color: #999999;
  }
}

.detail-content {
  width: 80%;
  margin: 25px auto 0 auto;
  font-size: 14px;
  color: #999999;
  line-height: 30px;
}
.detail-btns {
  width: 50%;
  max-width: 800px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 50px;
  .btn {
    width: 178px;
    height: 48px;
    background: #ffffff;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    text-align: center;
    line-height: 48px;
    cursor: pointer;
  }
}
</style>
